import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import plCommon from '@/locales/pl/common.json';
import plAuth from '@/locales/pl/auth.json';
import plTrainer from '@/locales/pl/trainer.json';
import plClient from '@/locales/pl/client.json';
import plBilling from '@/locales/pl/billing.json';
import plPlans from '@/locales/pl/plans.json';

import enCommon from '@/locales/en/common.json';
import enAuth from '@/locales/en/auth.json';
import enTrainer from '@/locales/en/trainer.json';
import enClient from '@/locales/en/client.json';
import enBilling from '@/locales/en/billing.json';
import enPlans from '@/locales/en/plans.json';

import deCommon from '@/locales/de/common.json';
import deAuth from '@/locales/de/auth.json';
import deTrainer from '@/locales/de/trainer.json';
import deClient from '@/locales/de/client.json';
import deBilling from '@/locales/de/billing.json';
import dePlans from '@/locales/de/plans.json';

export const SUPPORTED_LOCALES = ['pl', 'en', 'de'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'pl';

const resources = {
  pl: {
    common: plCommon,
    auth: plAuth,
    trainer: plTrainer,
    client: plClient,
    billing: plBilling,
    plans: plPlans,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    trainer: enTrainer,
    client: enClient,
    billing: enBilling,
    plans: enPlans,
  },
  de: {
    common: deCommon,
    auth: deAuth,
    trainer: deTrainer,
    client: deClient,
    billing: deBilling,
    plans: dePlans,
  },
} as const;

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES as unknown as string[],
    defaultNS: 'common',
    ns: ['common', 'auth', 'trainer', 'client', 'billing', 'plans'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'fitfive-locale',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  });

export const i18n = i18next;
